import {RootState} from '@/services/redux/rootReducer';
import {createSelector} from '@reduxjs/toolkit';

//==============================================//
// Hospital Admin common selectors
//==============================================//
export const hospitalAdminLoadingSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.isLoading],
    isLoading => isLoading,
);
export const hospitalAdminProfileEditLoadingSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.profileEditLoading],
    profileEditLoading => profileEditLoading,
);
export const hospitalAdminSuccessSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.hospitalAdminDashboardSuccess],
    hospitalAdminDashboardSuccess => hospitalAdminDashboardSuccess,
);
export const hospitalAdminFailureSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.hospitalAdminDashboardFailure],
    hospitalAdminDashboardFailure => hospitalAdminDashboardFailure,
);
export const hospitalAdminPocListLoadingSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.hospitalAdminPocListLoading],
    hospitalAdminPocListLoading => hospitalAdminPocListLoading,
);
export const hospitalPocSpecialistInviteLoadingSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.specialistInviteLoading],
    specialistInviteLoading => specialistInviteLoading,
);

//==============================================//
// Hospital Poc List related selectors
//==============================================//
export const hospitalAdminPocListSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.dashboard.admins],
    admins => admins,
);
export const hospitalAdminPocListCurrentPageSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.dashboard.current_page],
    current_page => current_page,
);
export const hospitalAdminPocListTotalPagesSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.dashboard.total_pages],
    total_pages => total_pages,
);
export const hospitalAdminPocListNextPageSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.dashboard.next_page],
    next_page => next_page,
);
export const hospitalAdminPocListTotalResultsSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.dashboard.total_results],
    total_results => total_results,
);

//==============================================//
// Hospital Poc Profile related selectors
//==============================================//
export const hospitalAdminProfileSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.hospitalPocProfile],
    hospitalPocProfile => hospitalPocProfile,
);

export const hospitalPocProfileSpecializationsSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.hospitalPocProfile?.specializations],
    specializations => specializations ?? [],
);

//==============================================//
// Hospital Specialist related selectors
//==============================================//
export const hospitalAdminSpecialistsSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.poc_dashboard.specialists],
    specialists => specialists,
);
export const hospitalAdminSpecialistsCurrentPageSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.poc_dashboard.current_page],
    current_page => current_page,
);  
export const hospitalAdminSpecialistsTotalPagesSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.poc_dashboard.total_pages],
    total_pages => total_pages,
);
export const hospitalAdminSpecialistsNextPageSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.poc_dashboard.next_page],
    next_page => next_page,
);
export const hospitalAdminSpecialistsTotalResultsSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.poc_dashboard.total_results],
    total_results => total_results,
);

export const hospitalAdminSpecialistsNoDataSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.poc_dashboard.no_data],
    no_data => no_data,
);

//==============================================//
// Hospital Consultation Case List related selectors
//==============================================//
export const hospitalAdminConsultationCaseListSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.consultation_cases.consultations],
    consultations => consultations,
);
export const hospitalAdminConsultationCaseListCurrentPageSelector = createSelector(
    [(state: RootState) => state.hospitalAdmin.consultation_cases.current_page],
    current_page => current_page,
);
export const hospitalAdminConsultationCaseListTotalPagesSelector = createSelector(  
    [(state: RootState) => state.hospitalAdmin.consultation_cases.total_pages],
    total_page => total_page
)
export const hospitalAdminConsultationCaseListNextPagesSelector = createSelector(  
    [(state: RootState) => state.hospitalAdmin.consultation_cases.next_page],
    next_page => next_page
)
export const hospitalAdminConsultationCaseListTotalResutltsSelector = createSelector(  
    [(state: RootState) => state.hospitalAdmin.consultation_cases.total_results],
    total_results => total_results
)

// ========================================
// all hospital specialist
// ========================================
export const hospitalSpecialistAll = createSelector(
    [(state: RootState) => state.hospitalAdmin.hospital_specialists_all],
    hospital_specialists_all => hospital_specialists_all
)